import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppContext } from "./AppContext";
import { ActiveOrderProvider } from "./ActiveOrderContext";
import { BasketProvider } from "./BasketContext";
import { LiveChatProvider } from "../modules/LiveChat";
import { LanguageProvider } from "../context/LanguageContext";
import Control from "../pages/Control";
import Dashboard from "../pages/Dashboard";
import TumMekanlar from "../pages/TumMekanlar";
import RestaurantDetails from "../pages/RestaurantDetails";
import Adreslerim from "../pages/Adreslerim";
import OrderHistory from "../pages/OrderHistory";
import Profil from "../pages/Profil";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import GoogleCallbackPage from "../pages/GoogleCallbackPage";
import LegalPage from "../pages/LegalPage";
export const route = (
 <LanguageProvider>
 <AppContext>
    <BrowserRouter>
      <ActiveOrderProvider>
      <BasketProvider>
      <LiveChatProvider>
      <Routes>

 <Route path="/" element={<Control item={<Dashboard />} />} />
  <Route path="/adreslerim" element={<Control item={<Adreslerim />} />} />
  <Route path="/restaurants" element={<Control item={<TumMekanlar />} />} />
  <Route path="/restaurants/:id" element={<Control item={<RestaurantDetails />} />} />
  <Route path="/orderhistory" element={<Control item={<OrderHistory />} />} />
  <Route path="/profil" element={<Control item={<Profil />} />} />
  <Route path="/Home/ResetPassword" element={<Control item={<ResetPasswordPage />} />} />
  <Route path="/google-callback" element={<GoogleCallbackPage />} />
  <Route path="/gizlilik-politikasi" element={<Control item={<LegalPage doc="privacy" />} />} />
  <Route path="/privacy-policy" element={<Control item={<LegalPage doc="privacy" />} />} />
  <Route path="/kullanim-kosullari" element={<Control item={<LegalPage doc="terms" />} />} />
  <Route path="/terms" element={<Control item={<LegalPage doc="terms" />} />} />
  <Route path="/hesap-silme" element={<Control item={<LegalPage doc="accountDeletion" />} />} />
  <Route path="/delete-account" element={<Control item={<LegalPage doc="accountDeletion" />} />} />
 
      </Routes>
      </LiveChatProvider>
      </BasketProvider>
      </ActiveOrderProvider>
    </BrowserRouter>
  </AppContext>
 </LanguageProvider>
);